import React from "react";
import { Menu, MenuItem } from "@mui/material";
import { LanguageCodeType, languageCodes } from "const/languageCodes";
import { changeLanguage } from "app/userSlice";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { StorageUtils } from "utils/storageUtils";
import { useMyInfoMutation } from "app/apiSlice";
import { ProviderUtils } from "utils/providerUtils";
import TokenService from "services/tokenService";

interface LanguageSelectorProps {
  anchorEl: SVGSVGElement | null;
  handleClose: () => void;
  type?: "ALL" | "ENG";
}

const LanguageSelector = ({
  anchorEl,
  handleClose,
  type = "ALL",
}: LanguageSelectorProps) => {
  // redux state
  const dispatch = useAppDispatch();
  const { language: currentLanguage } = useAppSelector((state) => state.user);

  // const { data: user } = useMyInfoQuery();
  // const userId = user?.userId;
  // const currentLanguage = user?.language;

  const [updateUser] = useMyInfoMutation();

  const languageOptions =
    type === "ALL"
      ? languageCodes
      : ([
          { code: "en", name: "English" },
          { code: "ko", name: "한국어" },
        ] as const);

  // Action
  const handleLanguageChange = (language: LanguageCodeType) => {
    handleClose();

    // 사용자 체감 반응성을 위해 언어를 먼저 즉시 반영
    StorageUtils.Language.set(language);
    dispatch(changeLanguage(language));

    if (!TokenService.getAccessToken()) {
      return;
    }

    updateUser({ language })
      .unwrap()
      .catch((error: unknown) => {
        console.error("Error updating language", error);
      });
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      className={`z-[100000] ${ProviderUtils.twPrefix}`}
    >
      {languageOptions.map((language): React.ReactElement => {
        const isSelected = language.code === currentLanguage;
        return (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            autoFocus={isSelected}
            sx={
              isSelected
                ? {
                    color: "primary.main",
                    fontWeight: "bold",
                    bgcolor: "primary.light",
                  }
                : {}
            }
            // className={clsx(
            //   "",
            //   isSelected &&
            //     `!font-bold ${providerClasses["bg-primary-light"]} ${providerClasses["text-primary"]}`
            // )}
          >
            {language.name}
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default LanguageSelector;
